<template>
  <div v-if="rooms.length === 0" class="mt-12 text-center">
    <v-btn
      color="primary"
      :disabled="locked"
      @click="enableTpvMode()"
    >
      <v-icon left v-text="icons.tpvMode" />
      {{ __('tpvMode') }}
    </v-btn>
  </div>
  <div v-else>
    <h-chips
      v-if="hasSeveralRooms"
      :rooms="rooms"
    />
    <v-window
      v-model="activeRoom"
      class="mt-2"
    >
      <h-room
        v-for="room in rooms"
        :key="room.id"
        :id="room.id"
        @book="$emit('book', $event)"
        @create="$emit('create', $event)"
        @preview="$emit('preview', $event)"
        @edit="$emit('edit', $event)"
      />
    </v-window>
  </div>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import Lockable from '@/Mixins/Lockable'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HChips from './Chips'
  import HRoom from './Room'

  export default {
    mixins: [
      I18n,
      Lockable,
      UsesIcons,
    ],

    components: {
      HChips,
      HRoom,
    },

    computed: {
      rooms () {
        return this.$store.getters['rummage/rooms']
      },
      hasSeveralRooms () {
        return this.rooms.length > 1
      },
      activeRoom: {
        get () {
          return this.$store.state.dashboard.room
        },
        set (v) {
          this.$store.commit('dashboard/room', v)
        },
      },
    },

    methods: {
      enableTpvMode () {
        if (this.locked) {
          return
        }
        this.lock(200)
        this.$store.commit('sync/skip')
        this.$store.commit('workingModes/enableTpvMode')
      },
    },
  }
</script>
